import React, { useContext } from "react";
import { Tabs, Tab, Box } from "@material-ui/core";
import Promotion from "views/Dashboard/Promotion/Promotion";
import MilestoneCriteria from "views/Dashboard/MilestoneCriteria/MilestoneCriteria";
import StackingPromotion from "views/Dashboard/StackingPromotion/StackingPromotion";

import Context from "context/context";
import { useHistory, useLocation } from "react-router-dom";

export default function PromotionTab() {
  const { state } = useContext(Context);

  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const isDental =
    state?.userInfo?.loyalty_organization_name ===
    "Henry Schein Dental";

  const isCanada =
    state?.userInfo?.loyalty_organization_name ===
    "Henry Schein Canada";

  const childTab = parseInt(params.get("childTab") || "0", 10);

  const handleChildTabChange = (event, newValue) => {
    params.set("childTab", newValue);

    history.replace({
      search: params.toString(),
    });
  };

  return (
    <Box>
      <Tabs
        value={childTab}
        onChange={handleChildTabChange}
        TabIndicatorProps={{
          style: { backgroundColor: "#007bff" },
        }}
      >
        {/* Tab 1 - Both Dental and Canada */}
        {(isDental || isCanada) && (
          <Tab label="Promotion Management" />
        )}

        {/* Tab 2 - Dental */}
        {isDental && (
          <Tab label="Unlocked Promotion Setup" />
        )}

        {/* Tab 2 - Canada */}
        {isCanada && (
          <Tab label="Promotion Stacking Setup" />
        )}
      </Tabs>

      <Box sx={{ p: 2 }}>
        {/* Tab 1 - Both Dental and Canada */}
        {childTab === 0 && (isDental || isCanada) && (
          <Promotion />
        )}

        {/* Tab 2 - Dental */}
        {childTab === 1 && isDental && (
          <MilestoneCriteria />
        )}

        {/* Tab 2 - Canada */}
        {childTab === 1 && isCanada && (
          <StackingPromotion />
        )}
      </Box>
    </Box>
  );
}